import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TrendDown2 icon
 *
 * @category Business
 */
const TrendDown2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M28.676 27.022c-.114-.102-.102-.204-.102-.51 0-1.13.011-3.63-.012-4.421-.17-.837-.757-.735-2.126-.735-.701.067-1.843-.215-2.284.35-.204.272-.159.577-.17 1.143-.034.904.08 3.313-.057 4.048-.395.238-1.142.08-1.617.125-.237 0-.396 0-.486-.034-.204-.057-.113-.294-.136-.747v-1.775c0-1.798.023-4.83-.011-6.356-.068-.373-.453-.713-1.267-.656-.69.023-2.002-.045-2.646.045-1.018.385-.566.95-.656 1.968v7.34c-.08.305-.317.18-.871.215-.577-.045-1.086.102-1.403-.102-.045-.769 0-10.993-.022-12.147-.226-1.198-2.432-.554-3.303-.712-.87-.068-1.402.317-1.278 1.165v11.637c-.124.329-1.753.102-2.035.148-.136 0-.204-.023-.227-.068-.067-.95.057-15.234-.056-16.897-.215-.486-.894-.554-1.493-.509H4.416c-.791.011-1.108.385-1.052 1.018v14.68c-.067 1.13.215 1.493-.237 1.945-.215.294-.158.78.18.928.238.079.351.022.804.045h24.384c.486.022.7-.758.282-1.052l-.068-.068zm-3.54-4.456c.52-.419 2.103-.35 2.34.18.057.125.057.25.057.385 0 1.188-.011 2.375-.022 3.563 0 .068 0 .147-.046.203-.067.08-.192.09-.294.09a26 26 0 0 1-1.866 0c-.079 0-.17 0-.226-.056-.08-.056-.09-.17-.09-.26 0-1.199-.012-2.386-.023-3.585 0-.113 0-.237.045-.35a.4.4 0 0 1 .136-.17zM18.35 18.64c.271-.09 1.99-.226 2.058.453.09 1.866.034 6.231.023 7.487-.046.192-.113.34-.35.373-.397.045-1.426.18-1.743-.249-.384-2.047-.034-5.259-.147-7.374.012-.192-.022-.509.09-.644l.069-.057zm-6.831-3.347c.418-.204 1.674-.17 1.968.328.282.497.147 1.085.18 1.696 0 2.613.012 6.537 0 8.731.159 1.052-1.752 1.244-2.25.566-.419-2.341-.034-5.384-.158-7.86.101-1.312-.227-2.443.18-3.393l.091-.068zM4.676 10.78c.78-.384 2.206-.023 2.172.905.045 3.37.022 11.694.011 14.488-.08 1.311-2.703.938-2.567-.328-.125-3.993-.023-9.998-.034-13.9 0-.384-.023-.848.294-1.086l.113-.068zm23.672 4.299c-.272-.407-.724-.916-1.098-1.391-.644-.702-.7-1.131-1.323-1.233-1.436.384.543 1.696.566 2.296-6.435-.249-12.86-3.257-17.655-8.03-.904-.848-1.606-1.855-2.465-2.726-.272-.215-.656-.203-.803.08-.125.203-.057.497.09.746.701.984 1.516 1.855 2.353 2.703a28.88 28.88 0 0 0 17.677 8.38c1.142.023-.317.679-.611 1.177-.249.339-.023.882.373.87.294.012.51-.18.905-.509l1.323-1.085c.52-.407.713-.52.701-1.154l-.045-.113z"
        />
      </svg>
    );
  }
);

TrendDown2.displayName = 'TrendDown2';

export { TrendDown2 };
